import { useRequest } from "ahooks";

import service from "../../api/HTTPClient";

const useStatus = (options?: ObjectRecord) => {
    const request = () => {
		return new Promise((resolve, reject) => {
			service.request({ method: "GET" })
				.then(resolve)
				.catch(reject);
		});
	};

	return useRequest(request, options)
}

export default useStatus;
